export default Object.freeze({
  REFRESH_CACHED_EVENTS: 'refreshCachedEvents',
  LOAD_MASTER_ARENAS: 'loadMasterArenas',
  LOAD_MERCHANDISE_TYPES: 'laodMerchandiseTypes',
});
